// import lib
import { lazy } from "react";

const routes = [
  {
    exact: true,
    path: "/dashboard",
    element: lazy(() => import("../pages/Dashboard")),
  },
];

export default routes;
